import * as React from "react";
import { titleStore } from "Stores/TitleStore";
import { useTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";

interface RouteWithTitleProps extends React.PropsWithChildren {
  pageName?: string;
}

export const RouteWithTitle = ({ children, pageName }: RouteWithTitleProps) => {
  const { t } = useTranslation(I18N_NS.GENERAL);
  React.useEffect(() => {
    if (pageName) {
      titleStore.setPageName(t(pageName));
    } else {
      titleStore.setPageName("");
    }
  }, []);
  return <>{children}</>;
};

RouteWithTitle.displayName = "RouteWithTitle";
